import { combineReducers } from 'redux';

import { Action } from 'Libs/redux/actions';

import { activityReducer, activityState } from './activity/activity.slice';
import { ActivityState } from './activity/activity.type';
import { reducer as audienceGroupReducer, audienceGroupState } from './audience-group/audience-group.slice';
import { AudienceGroupState } from './audience-group/audience-group.types';
import { magicCodeInitialState, magicCodeReducer } from './configuration/magic-codes/magic-codes.slice';
import { MagicCodeState } from './configuration/magic-codes/magic-codes.types';
import { thematicReducer, thematicState } from './configuration/thematic/thematic.slice';
import { ThematicState } from './configuration/thematic/thematic.types';
import { drawerContentReducer, drawerContentState } from './content/content-drawer/content-drawer.slice';
import { DrawerContentState } from './content/content-drawer/content-drawer.types';
import type { ContentState } from './content/content.types';
import { contentReducer, contentState } from './content/content/content.slice';
import { initialState as contentListInitialState, contentListReducer } from './content/list/content.list.slice';
import type { State as ContentListState } from './content/list/content.list.types';
import { entityPlayersInitialState, entityPlayersReducer } from './entity-players/entity-players.slice';
import { EntityPlayersState } from './entity-players/entity-players.type';

export type Entities = {
  activity: ActivityState;
  audienceGroup: AudienceGroupState;
  // TODO: could be merged with content
  contentList: ContentListState;
  content: ContentState;
  drawerContent: DrawerContentState;
  entityPlayers: EntityPlayersState;
  magicCode: MagicCodeState;
  thematic: ThematicState;
};

export const entityState: Entities = {
  activity: activityState,
  audienceGroup: audienceGroupState,
  contentList: contentListInitialState,
  content: contentState,
  drawerContent: drawerContentState,
  entityPlayers: entityPlayersInitialState,
  magicCode: magicCodeInitialState,
  thematic: thematicState,
};

export const entityReducers = combineReducers<Entities, Action>({
  activity: activityReducer,
  audienceGroup: audienceGroupReducer,
  contentList: contentListReducer,
  content: contentReducer,
  drawerContent: drawerContentReducer,
  entityPlayers: entityPlayersReducer,
  magicCode: magicCodeReducer,
  thematic: thematicReducer,
});
